import BaseApiRequest from "./BaseApiRequest";
import { VAULT_MEMBER_URL, VAULT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class UpdateVaultMemberRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = [];

  url = VAULT_MEMBER_URL;

  constructor(request) {
    super();

    if (request.inSessionJoint) {
      this.url = VAULT_URL + request.inSessionJoint;
    }
    this.body = request;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
